export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "org_invoice_payment": {
            "payment_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de pago"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto"])},
            "exchange_rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de cambio"])},
            "interbank_commission": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comisión interbancaria"])}
          }
        }
      },
      "en": {
        "model": {
          "org_invoice_payment": {
            "payment_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payment date"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount"])},
            "exchange_rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exchange rate"])},
            "interbank_commission": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Interbank commission"])}
          }
        }
      }
    }
  })
}